import { IApiClient } from "@common/network/interfaces";
import { ApiClient } from "@network/client";
import { DataUtility as _ } from "@utils/DataUtility";
import {
  IFetchFormSubmissionsPayload,
  IFormSubmission,
  IFetchFormSubmissionsDataToExportRepositoryPayload,
  ISubmissionFormDataServer,
  IFetchMySubmissionsPayload,
  IDuplicateCheckFormData,
  IFieldSubmissionMap,
  IBulkSubmissionFormDataServer,
  IOtpRequest,
} from "@common/redux/formSubmission/interface";
import { getAuthSessionToken } from "@common/network/utils";
import { getConfig } from "@config/index";
import store from "@store/index";

import {
  checkDuplicate,
  fetchSubmisison,
  fetchSubmissionBySubmissionId,
  formSubmissionsExport,
  submission,
  publicCheckDuplicate,
  deleteSubmission,
  bulkSubmission,
  updateBulkSubmission,
  sendOrValidateOTP,
} from "../apis/urls";
import { TENAX_BASE_URL } from "./utils";

const ENDPOINTS = {
  formSubmission: () => submission,
  sendOrValidateOTP: () => sendOrValidateOTP,
  formBulkSubmission: () => bulkSubmission,
  updateFormBulkSubmission: () => updateBulkSubmission,
  deleteSubmission: () => deleteSubmission,
  publicFormSubmission: () => "api/form-service/public/form/submission",
  formSubmissionV1: () => `api/form-service/v1/form/submission`,
  resubmission: () => `api/form-service/form/submission/resub`,
  checkDuplicate: () => checkDuplicate,
  publicCheckDuplicate: () => publicCheckDuplicate,
  fetchMySubmissions: () => fetchSubmisison,
  fetchSubmissionBySubmissionId: () => fetchSubmissionBySubmissionId,
  formSubmissionsExport: () => formSubmissionsExport, //should correct it
  pinCodeData: () => `api/form-service/public/pincodeLocation`,
  formDraft: () => `api/form-service/form/submission/draft`,
  publicFormDraft: () => `api/form-service/public/form/submission/draft`, // NEED TO CHECK OF THE USE CASE
  formOpened: () => `api/form-service/form/opened`
};


class FormSubmissionRepository {
  private apiClient: IApiClient;
  constructor(apiClient: IApiClient) {
    this.apiClient = apiClient;
  }


  public updateFormSubmission = (
    formId: string,
    submissionData: IFormSubmission
  ) => {
    const dbFormatedFieldSubmissionMap: IFieldSubmissionMap = {};

    const dbFormattedSubmissionData = _.cloneDeep(submissionData);

    Object.keys(submissionData.fieldSubmissionMap).map(function (key) {
      if (submissionData.fieldSubmissionMap[key])
        dbFormatedFieldSubmissionMap[key] =
          submissionData.fieldSubmissionMap[key];
    });
    dbFormattedSubmissionData.fieldSubmissionMap = dbFormatedFieldSubmissionMap;

    const existingFormSubmissions = JSON.parse(
      localStorage.getItem("formSubmissions") ?? "{}"
    );
    const formSubmissions = existingFormSubmissions || [];
    formSubmissions.length > 0 &&
      formSubmissions.map((existingFormSubmissionData, formIndex) => {
        existingFormSubmissionData &&
          existingFormSubmissionData.formId == formId &&
          formSubmissions[formIndex].submissions.map(
            (existingSubmissionData, submissionIndex) => {
              if (
                existingSubmissionData.localId ==
                dbFormattedSubmissionData.localId
              ) {
                formSubmissions[formIndex].submissions[submissionIndex] =
                  dbFormattedSubmissionData;
              }
            }
          );
      });
    localStorage.setItem("formSubmissions", JSON.stringify(formSubmissions));

    const response = { dbFormattedSubmissionData };
    if (response) {
      return { response };
    } else {
      const error = "error";
      return { error };
    }
  };

  public addFormSubmission = async (
    formSubmissionData: ISubmissionFormDataServer
  ) => {
    const isTokenFound = store.getState().auth.isAuthenticated;
    const payload = formSubmissionData;
    const result = await this.apiClient.post(
      isTokenFound
        ? ENDPOINTS.formSubmission()
        : ENDPOINTS.publicFormSubmission(),
      payload,
      {},
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );

    return result.data;
  };

  public sendOrValidateOTP = async (
    otpRequest: IOtpRequest
  ) => {
    const isTokenFound = store.getState().auth.isAuthenticated;
    const payload = [otpRequest];
    const result = await this.apiClient.post(
      isTokenFound
      && ENDPOINTS.sendOrValidateOTP(),
      payload,
      {},
      {
        baseURL: TENAX_BASE_URL,
      }
    );
    return result.data;
  };

  public formOpenedApi = async (
    formSubmissionData: { formId: string, isSubmitted: boolean, openedDate: number }
  ) => {
    const isTokenFound = store?.getState()?.auth?.isAuthenticated || false;
    const payload = formSubmissionData;
    const result = await this.apiClient.post(
      isTokenFound
      && ENDPOINTS.formOpened(),
      payload,
      {},
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return result.data;
  };

  public addBulkFormSubmission = async (
    formSubmissionData: IBulkSubmissionFormDataServer
  ) => {
    const isTokenFound = store.getState().auth.isAuthenticated;
    const payload = formSubmissionData;
    const result = await this.apiClient.post(
      isTokenFound
      && ENDPOINTS.formBulkSubmission(),
      payload,
      {},
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return result.data;
  };
  public updateBulkFormSubmission = async (
    formSubmissionData: IBulkSubmissionFormDataServer
  ) => {
    const isTokenFound = store.getState().auth.isAuthenticated;
    const payload = formSubmissionData;
    const result = await this.apiClient.put(
      isTokenFound
      && ENDPOINTS.updateFormBulkSubmission(),
      payload,
      {},
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return result.data;
  };

  // HTTP(S) request to (POST)::> "form/submission/draft" //
  public addFormDraft = async (
    formSubmissionData: ISubmissionFormDataServer
  ) => {
    const isTokenFound = store.getState().auth.isAuthenticated;
    const payload = formSubmissionData;
    const result = await this.apiClient.post(
      isTokenFound ? ENDPOINTS.formDraft() : ENDPOINTS.publicFormDraft(), // NEED TO CHECK OF THE USE CASE
      payload,
      {},
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return result.data;
  };

  public deleteFormSubmission = (formId: string, submissionId: string) => {
    const existingFormSubmissions = JSON.parse(
      localStorage.getItem("formSubmissions") ?? "{}"
    );
    const formSubmissions = existingFormSubmissions || [];
    formSubmissions.length > 0 &&
      formSubmissions.map((existingFormSubmissionData, formIndex) => {
        existingFormSubmissionData &&
          existingFormSubmissionData.formId == formId &&
          formSubmissions[formIndex].submissions.map((existingSubmission) => {
            if (existingSubmission.localId == submissionId) {
              formSubmissions[formIndex].submissions = [
                ...formSubmissions[formIndex].submissions.slice(0, formIndex),
                ...formSubmissions[formIndex].submissions.slice(formIndex + 1),
              ];
            }
          });
      });
    localStorage.setItem("formSubmissions", JSON.stringify(formSubmissions));

    const response = { status: 200 };
    if (response) {
      return { response };
    } else {
      const error = "error";
      return { error };
    }
  };

  public fetchFormSubmission = () => {
    const formSubmissions = JSON.parse(
      localStorage.getItem("formSubmissions") // formSubmissions    [{formId:formid, submissions:[{s11},{s12}]}]
    );

    const response = { formSubmissions };
    if (response) {
      return { response };
    } else {
      const error = "error";
      return { error };
    }
  };

  // public fetchExistingFormSubmissionData = (existingFormSubmissionId:string) => {
  //   const formSubmissions = JSON.parse(
  //     getItem("formSubmissions")

  //   );
  //   existingFormSubmissionId
  //   const response = { formSubmissions };
  //   if (response) {
  //     return { response };
  //   } else {
  //     const error = "error";
  //     return { error };
  //   }
  // };

  public fetchMySubmissions = async (data: IFetchMySubmissionsPayload) => {
    const params = data;
    const result = await this.apiClient.get(
      ENDPOINTS.fetchMySubmissions(),
      params,
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return result.data;
  };

  public fetchSubmissionBySubmissionId = async (submissionId: string,roleName?: string ) => {
    const result = await this.apiClient.get(
   ENDPOINTS.fetchSubmissionBySubmissionId() + submissionId+(roleName ? `?roleName=${roleName}` : ""),
        {},
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return result.data;
  };

  public fetchFormSubmissions = async (
    formSubmissionPayload: IFetchFormSubmissionsPayload
  ) => {
    const { formIds, pageNumber, pageSize } = formSubmissionPayload;
    const formIdsToString: string = formIds.toString();
    const params = {
      formId: formIdsToString,
      pageNumber: pageNumber,
      pageSize: pageSize,
    };
    const result = await this.apiClient.get(
      ENDPOINTS.formSubmissionV1(),
      params,
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return result.data;
  };

  public formSubmissionsExport = async (
    submissionExportApiPayload: IFetchFormSubmissionsDataToExportRepositoryPayload
  ) => {
    const { formId, fromDate, toDate, fileType } = submissionExportApiPayload;
    const clientToken = getAuthSessionToken();
    const result = await fetch(
      getConfig().APP_BE_BASE_URL +
      ENDPOINTS.formSubmissionsExport() +
      "?formId=" +
      formId +
      "&fromDate=" +
      fromDate +
      "&toDate=" +
      toDate +
      "&fileType=" +
      fileType,
      {
        method: "GET",
        headers: {
          "Content-type": "blob", //"vnd.ms-excel",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + clientToken,
        },
      }
    );
    if (result.status == 404) {
      //unable to handle in sagas
      throw { message: "404" };
    }
    const response = await result.blob();
    return response;
  };

  public fetchFormSubmissionSettings = async (formId: string) => {
    const payload = { formId };
    const isTokenFound = store.getState().auth.isAuthenticated;
    const result = await this.apiClient.post(
      isTokenFound
        ? ENDPOINTS.formSubmission()
        : ENDPOINTS.publicFormSubmission(),
      payload,
      {},
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    result.data;
    return result.data;
  };
  public fetchPincodeData = async (pincode: string, countryCode: string) => {
    const result = await this.apiClient.get(
      ENDPOINTS.pinCodeData(),
      { pincode, countryCode },
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return await result;
  };
  public resubmitFormSubmission = async (
    formSubmissionData: ISubmissionFormDataServer,
    roleName?: string
  ) => {
    const payload = formSubmissionData;
    const result = await this.apiClient.put(
      ENDPOINTS.resubmission() +
        (roleName ? `?roleName=${roleName}` : ""),
      payload,
      {},
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return result.data;
  };

  public checkDuplicateSubmission = async (
    duplicateCheckData: IDuplicateCheckFormData
  ) => {
    const isTokenAvailabe = store.getState().auth.isAuthenticated;
    const payload = duplicateCheckData;
    const result = await this.apiClient.post(
      isTokenAvailabe
        ? ENDPOINTS.checkDuplicate()
        : ENDPOINTS.publicCheckDuplicate(),
      payload,
      {},
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return result.data;
  };

  public deleteFormSubsmission = async (submissionId: string) => {
    const result = await this.apiClient.delete(
      `${ENDPOINTS.deleteSubmission()}?ids=${submissionId}`,
      {},
      {});
    return result.data;
  };
}


const formSubmissionRepository = new FormSubmissionRepository(ApiClient);

export { formSubmissionRepository as FormSubmissionRepository };
